<template>
    <div id="detalhamentoEstadoSelect">
        <select v-model="detalhe">
            <option value="" disabled selected>Selecione...</option>
            <option v-for="op in options"
                    :value="op.value">{{ op.text }}
            </option>
        </select>
        <label>{{ label }}</label>
    </div>
</template>

<script>
    $(document).ready(function() {
        $('select').material_select();
    });

    export default {
        data: () => ({
            detalhe: '',
            label: "Detalhamento do estado",
            options: [
                {value: 1, text: "Efetuada com sucesso"},
                {value: 2, text: "Remarcada"},
                {value: 3, text: "Não estava presente"},
                {value: 4, text: "Cancelada"},
            ],
        })
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/form/DetalhamentoEstadoSelect.vue